import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages } from 'react-intl';
import Calendar from '../../components/Calendar';
import CalendarToolbarAgenda from '../../components/CalendarToolbarAgenda';
import generateEvents from './date-utils';
import RepVisitsAgendaUnlockPage from './repvisits-agenda-unlock';
import * as constants from '../Authorization/constants';
import './styles.css';

const messages = defineMessages({
  noEvents: {
    id: 'repvisits.calendar.noEvents',
    defaultMessage: 'No events found in the selected date range',
  },
});

const CustomDateHeader = ({ label, onDrillDown }) => (
  <div styleName="custom-date-header" className="custom-date-header">
    { /* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
    <a href="#" onClick={onDrillDown}>
      {label}
    </a>
  </div>
);

CustomDateHeader.propTypes = {
  label: PropTypes.node,
  onDrillDown: PropTypes.func,
};

class AvailabilityCalendar extends React.PureComponent {
  static propTypes = {
    visibleEventTypes: PropTypes.object,
    onView: PropTypes.func,
    onNavigate: PropTypes.func,
    view: PropTypes.string,
    date: PropTypes.object,
    components: PropTypes.object,
    onSelectEvent: PropTypes.func,
    importedEvents: PropTypes.array,
    onDayClick: PropTypes.func,
    setFromToRange: PropTypes.func,
    fromDateObj: PropTypes.instanceOf(Date),
    toDateObj: PropTypes.instanceOf(Date),
    length: PropTypes.number,
    viewer: PropTypes.object,
  };

  render() {
    const {
      viewer,
      onView,
      components,
      onNavigate,
      onSelectEvent,
      view,
      date,
      visibleEventTypes,
      importedEvents,
      onDayClick,
      setFromToRange,
      fromDateObj,
      toDateObj,
      length,
    } = this.props;
    const scrollToTime = new Date(2017, 1, 1, 7, 0, 0);
    const freemiumStyle = get(viewer, 'heAccount.freemium') ? 'no-print-freemium' : '';
    const events = generateEvents(viewer.repVisitsEvents, viewer.enabledFeatures).filter((event) => (
      event.pendingStatus ? visibleEventTypes.pending : visibleEventTypes[event.type]
    ));

    const upgradeViews = { day: true, week: true, month: true, agenda: RepVisitsAgendaUnlockPage };
    const regularViews = { day: true, week: true, month: true, agenda: true };
    const isFreemium = viewer.heAccount.freemium || !viewer.heAccount.activeSubscriptions.includes(constants.REP_VISITS_SUBSCRIPTION);
    const calendarViews = isFreemium ? upgradeViews : regularViews;
    const isDisplayingAgenda = view === 'agenda';

    const fromDate = fromDateObj ? fromDateObj.setHours(0) : fromDateObj;

    return (
      <div styleName="calendar-container">
        {isDisplayingAgenda && (
        <CalendarToolbarAgenda
          currentDate={fromDateObj}
          lastDate={toDateObj}
          onDayClick={onDayClick}
          setFromToRange={setFromToRange}
        />
        )}
        { !isFreemium && isDisplayingAgenda && events.length === 0 && (
        <div id="no-events-msg" styleName="no-events-message">
          <FormattedMessage {...messages.noEvents} />
        </div>
        )}
        <Calendar
          className={`rep-visits-rbc-calendar${isDisplayingAgenda ? ' has-agenda' : ''}`}
          components={{
            ...components,
            dateHeader: CustomDateHeader,
          }}
          popup
          events={[].concat(events, importedEvents)}
          views={calendarViews}
          onView={onView}
          onSelectEvent={onSelectEvent}
          onNavigate={onNavigate}
          view={view}
          date={isDisplayingAgenda ? fromDate : date}
          scrollToTime={scrollToTime}
          styleName={freemiumStyle}
          length={length}
        />
      </div>
    );
  }
}

export default AvailabilityCalendar;
